var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1783 358L1783 386",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1783.5,
    cy: 353.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1778.99 353.19C1778.99 349.283 1782.29 346.117 1786.36 346.117C1786.94 346.117 1787.51 346.184 1788.06 346.308C1786.74 345.48 1785.19 345 1783.52 345C1778.81 345 1775 348.806 1775 353.5C1775 358.194 1778.81 362 1783.52 362C1785.81 362 1787.89 361.093 1789.43 359.62C1788.49 360.032 1787.45 360.263 1786.36 360.263C1782.29 360.263 1778.99 357.096 1778.99 353.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1792.4 352.6L1792.37 350.146L1790.54 351.719L1788.3 351.056L1789.11 353.337L1787.77 355.381L1790.1 355.218L1791.5 357.144L1792.13 354.763L1794.34 353.909L1792.4 352.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.bb0f660bbcbfda4521c3874ae664ce82.svg";
export { ForwardRef as ReactComponent };